import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, tv } from '@costar-ui/cosmos';
import spacingOptions from '../../common/space-options/spacing-options.esm.js';

// using slots we have to designate the target slot in variant definition
var gap = Object.keys(spacingOptions.gap).reduce(function (acc, cur) {
  return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, cur, {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    base: spacingOptions.gap[cur]
  }));
}, {});
var checkboxGroupTv = getTvObject({
  slots: {
    base: 'relative flex items-start overflow-hidden',
    label: 'w-full border border-focus',
    subText: 'w-full'
  },
  variants: {
    gap: gap,
    layout: {
      grid: {
        base: 'flex flex-col'
      },
      relative: {
        label: 'absolute -translate-y-full leading-5',
        subText: 'absolute bottom-0 translate-y-full'
      }
    },
    screenReaderOnly: {
      "true": {
        label: 'sr-only',
        subText: 'sr-only'
      }
    }
  }
});
var checkboxGroupStyles = tv(checkboxGroupTv);

export { checkboxGroupStyles, checkboxGroupTv };
//# sourceMappingURL=checkbox-group.styles.esm.js.map
